/**
* @Description: 语法学习-自主测试
* @author Wangshu
* @date 2020-04-07
*/
<template>
  <div class="zitest-warp">
    <div class="unitList">
      <div
        class="unit-block"
        :class="[item.is_try==0?'lock':'allow-active',item.is_pass==1?'green-active':'',item.is_pass==2?'green-active':'']"
        v-for="(item,index) in unitList"
        @click="selectUnit(item.id,item.is_try)"
        :key="'b'+index"
      >
        <div class="unit-btn" :class="item.is_try==0?'':'allow-active'">
          <div>{{item.name}}</div>
        </div>
        <img v-if="item.is_try==0" class="lock-icon" src="@/assets/img/grammarTest/lock.png" alt />
        <img
          v-if="item.is_pass==2&&item.is_try==1"
          class="lock-icon"
          src="@/assets/img/grammarTest/perform.png"
          alt
        />
        <transition name="el-zoom-in-center">
          <div class="lock-unit" v-if="showPopText&&option.testPaperId==item.id">还未学习该单元单词</div>
        </transition>
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <PopBook v-if="testPaper">
        <template slot="header">
          <div class="pop-title">自主测试</div>
          <div class="pop-btn td-fsc">
            <!-- <img class="btn" src="@/assets/img/grammarTest/music.png" alt /> -->
            <img class="btn" @click="testPaper=false" src="@/assets/img/grammarTest/close.png" alt />
          </div>
          <div class="line"></div>
        </template>
        <template slot="content">
          <div class="left-title">自主测试：自由选择测试的方式与试题数目，用以巩固学习效果。</div>
          <div class="zizhu-content-box">
            <div class="option-box">
              <div class="test-tilt" key="save">测试选项</div>
              <div class="option">
                <div class="option-item">
                  <div>测试内容：</div>
                  <el-checkbox-group v-model="checkList" size="medium">
                    <el-checkbox label="选择">选择</el-checkbox>
                    <el-checkbox label="填空">填空</el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="option-item">
                  <div>每组语法数：</div>
                  <el-select v-model="option.grammarNum" clearable placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      size="medium"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div class="push-btn">
                  <el-button type="success" @click="startComparisonTest">开始测试</el-button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </PopBook>
    </transition>
    <transition name="el-fade-in-linear" mode="out-in">
      <test-paper
        ref="testPaper"
        :type="testPaperType"
        :showComparison="showComparison"
        :option="option"
        @closeComparison="closeText"
      ></test-paper>
    </transition>
  </div>
</template>

<script>
import testPaper from "../../templates/unitTest/testPaper";
import { getUnitList } from "../../../../api/grammar";
import Lockr from "lockr";

export default {
  components: { testPaper },
  data() {
    return {
      courseId: "", //课程id
      unitList: [], //单元列表
      testPaper: false,
      checkList: [],
      options: [
        { value: "10", label: "10" },
        { value: "15", label: "15" },
        { value: "20", label: "20" },
      ],
      showComparison: false,
      testPaperType: "2", //控制组件使用的接口
      option: {
        name: "自主测试",
        testPaperId: "", //单元Id
        is_select: 0, //是否有选择
        is_write: 0, //是否有填空
        grammarNum: "10",
      },
      showPopText: "",
    };
  },
  methods: {
    selectUnit(id, is_try) {
      this.option.testPaperId = id;
      if (is_try == 0) {
        this.showPopText = true;
        setTimeout(() => {
          this.showPopText = false;
        }, 2000);
        return null;
      }
      this.testPaper = true;
    },
    //获取单元列表
    getUnitList() {
      this.courseId = this.$route.query.id;
      let params = {
        token: Lockr.get("token"),
        grammar_curriculum_id: this.courseId,
        type: 2,
      };
      getUnitList(params).then((res) => {
        this.unitList = res.data; //单元列表
      });
    },
    // 开始对比测试
    startComparisonTest() {
      this.option.is_select = 0;
      this.option.is_write = 0;
      this.checkList.map((item) => {
        if (item == "选择") {
          this.option.is_select = 1;
        }
        if (item == "填空") {
          this.option.is_write = 1;
        }
      });
      if (this.option.is_select == 0 && this.option.is_write == 0) {
        this.$alert("请选择测试的内容哦~", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      } else if (this.option.grammarNum == "") {
        this.$alert("请选择每组单词数~", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      } else {
        this.showComparison = true;
        this.$refs.testPaper.getTestPaper();
        this.testPaper = false;
      }
    },
    // 关闭对比测试
    closeText() {
      this.showComparison = false;
    },
  },
  created() {
    this.getUnitList();
  },
};
</script>

<style scoped lang='less'>
.zitest-warp {
  .unitList {
    border: 1px solid #dedede;
    margin: 0 10px;
    display: flex;
    flex-wrap: wrap;

    .unit-block {
      width: 18%;
      height: 70px;
      margin: 10px 1%;
      background: linear-gradient(
        270deg,
        rgba(255, 197, 103, 1) 0%,
        rgba(255, 157, 0, 1) 100%
      );
      display: flex;
      align-items: center;
      justify-content: center;
      /*flex-direction: column;*/
      font-size: 19px;
      color: #fff;
      cursor: pointer;
      position: relative;
      transition: all 0.3s;
      overflow: unset;
      position: relative;

      .unit-btn {
        flex: 1;
        transition: all 0.5s;

        > div {
          height: 70px;
          line-height: 70px;
          text-align: center;
        }
      }

      .lock-unit {
        position: absolute;
        top: -50%;
        left: 20px;
        font-size: 14px;
        white-space: nowrap;
        padding: 5px 8px;
        background: #00b29f;
      }

      .lock-unit:before {
        position: absolute;
        border: 5px solid;
        border-color: #00b29f transparent transparent transparent;
        content: "";
        bottom: -10px;
      }

      .green-active {
        background: #00d8a0;
      }

      .allow-active:hover {
        background: #ff640c;
      }

      .unit-hidden {
        margin-right: -35px;
        transition: all 0.5s;
        width: 35px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        > div {
          width: 35px;
          height: 35px;
          transition: all 0.5s;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        > div:hover {
          background: #ff640c;
        }

        .video-icon {
          width: 20px;
          height: 20px;
        }

        .bell-icon {
          width: 20px;
          height: 20px;
        }
      }
    }

    .allow-active:hover {
      box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);

      .unit-hidden {
        margin-right: 0;
      }
    }

    .lock {
      background: #818181;
    }

    .lock:hover {
      background: #818181;
      box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    }

    .lock-icon {
      position: absolute;
      bottom: 5px;
      right: 5px;
      height: 25px;
      width: 25px;
    }
  }

  .left-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    height: 44px;
    line-height: 44px;
    background: #fff9ef;
    border-radius: 4px;
    border: 1px solid #f5a623;
    padding: 0 20px;
    margin-top: 10px;
  }

  .zizhu-content-box {
    height: 450px;
    transition: all 0.5s;
  }

  .option-box {
    .test-tilt {
      font-size: 26px;
      text-align: center;
      margin-top: 25px;
    }

    .option {
      margin: 0 auto;
      margin-top: 50px;
      width: 550px;

      .option-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 20px 0;
        font-size: 22px;

        > div:nth-of-type(1) {
          margin-left: 20px;
          width: 140px;
        }

        > div:nth-of-type(2) {
          .el-checkbox__label {
            font-size: 30px;
          }
        }
      }
    }

    .push-btn {
      text-align: center;
      margin-top: 100px;
    }
  }
}
</style>